import { createAction } from '@reduxjs/toolkit';
import { ResolvedResponse, Status } from '@innovyze/lib-am-common';
import {
	DeteriorationModel,
	GetDeteriorationModelCurveConfigsPaginatedRequest,
	GetDeteriorationModelsPaginatedRequest,
	GetDeteriorationModelAssetsResultsPaginatedRequests,
	GetDeteriorationModelGroupsResultsPaginatedRequests,
	ExtendedDeteriorationModelStatus,
	CurveConfig,
} from '@Types/deteriorationModels.types';
import { addNamespace } from '@Utils/actions';

export const listDeteriorationModels = createAction<GetDeteriorationModelsPaginatedRequest>(
	addNamespace('deteriorationModels/list'),
);

export const listDeteriorationModelsResolved = createAction<ResolvedResponse>(
	addNamespace('deteriorationModels/listResolved'),
);

export const listDeteriorationModelsRejected = createAction<Status>(addNamespace('deteriorationModels/listRejected'));

export const resetDeteriorationModels = createAction(addNamespace('deteriorationModels/reset'));

export const getDeteriorationModel = createAction<{ id: string }>(addNamespace('deteriorationModels/get'));

export const getDeteriorationModelResolved = createAction<DeteriorationModel>(
	addNamespace('deteriorationModels/getResolved'),
);

export const getDeteriorationModelRejected = createAction<Status>(addNamespace('deteriorationModels/getRejected'));

export const getDeteriorationModelStatus = createAction<{ id: string }>(addNamespace('deteriorationModels/getStatus'));

export const getDeteriorationModelStatusResolved = createAction<{
	id: string;
	status: ExtendedDeteriorationModelStatus;
}>(addNamespace('deteriorationModels/getStatusResolved'));

export const getDeteriorationModelStatusRejected = createAction<Status>(
	addNamespace('deteriorationModels/getStatusRejected'),
);

export const listDeteriorationModelCurveConfigsAction = createAction<
	GetDeteriorationModelCurveConfigsPaginatedRequest | undefined
>(addNamespace('deteriorationModels/curveConfigs/list'));

export const listDeteriorationModelCurveConfigsResolved = createAction<{
	response: ResolvedResponse;
	curveConfigs: CurveConfig[];
}>(addNamespace('deteriorationModels/curveConfigs/listResolved'));

export const listDeteriorationModelCurveConfigsRejected = createAction<Status>(
	addNamespace('deteriorationModels/curveConfigs/listRejected'),
);

export const getIndustryStandardCurvesAction = createAction(
	addNamespace('deteriorationModels/industryStandardCurves/get'),
);

export const getIndustryStandardCurvesResolved = createAction<
	{
		displayName: string;
		key: string;
	}[]
>(addNamespace('deteriorationModels/industryStandardCurves/getResolved'));

export const listDeteriorationModelAssetsResultsAction =
	createAction<GetDeteriorationModelAssetsResultsPaginatedRequests>(
		addNamespace('deteriorationModels/assetsResults/list'),
	);

export const listDeteriorationModelAssetsResultsResolved = createAction<ResolvedResponse>(
	addNamespace('deteriorationModels/assetsResults/listResolved'),
);

export const listDeteriorationModelAssetsResultsRejected = createAction<Status>(
	addNamespace('deteriorationModels/assetsResults/listRejected'),
);

export const resetDeteriorationModelAssetsResults = createAction(
	addNamespace('deteriorationModels/assetsResults/reset'),
);

export const listDeteriorationModelGroupsResultsAction =
	createAction<GetDeteriorationModelGroupsResultsPaginatedRequests>(
		addNamespace('deteriorationModels/groupsResults/list'),
	);

export const listDeteriorationModelGroupsResultsResolved = createAction<ResolvedResponse>(
	addNamespace('deteriorationModels/groupsResults/listResolved'),
);

export const listDeteriorationModelGroupsResultsRejected = createAction<Status>(
	addNamespace('deteriorationModels/groupsResults/listRejected'),
);

export const getGlobalUndefinedCountAction = createAction<{
	modelId: string;
}>(addNamespace('deteriorationModels/globalCount/list'));

export const getGlobalUndefinedCountResolved = createAction<{
	response: ResolvedResponse;
}>(addNamespace('deteriorationModels/globalCount/listResolved'));

export const getGlobalUndefinedCountRejected = createAction<Status>(
	addNamespace('deteriorationModels/globalCount/listRejected'),
);

export const setPaginationState = createAction<{
	modelId: string;
	tab: 'configuration' | 'groups' | 'assets';
	paginationRequest:
		| GetDeteriorationModelCurveConfigsPaginatedRequest
		| GetDeteriorationModelAssetsResultsPaginatedRequests
		| GetDeteriorationModelGroupsResultsPaginatedRequests;
}>(addNamespace('deteriorationModels/setPaginationState'));

export const clearPaginationState = createAction<{
	modelId: string;
}>(addNamespace('deteriorationModels/clearPaginationState'));

/** The grade card whose breakdown is open on the Results tab; '' when none is. */
export const setSelectedBreakdownGrade = createAction<{
	modelId: string;
	grade: string;
}>(addNamespace('deteriorationModels/setSelectedBreakdownGrade'));

export const updatePublishedStatus = createAction<{
	modelId: string;
	published: boolean;
}>(addNamespace('deteriorationModels/updatePublishedStatus'));

export const updatePublishedStatusResolved = createAction<{
	modelId: string;
	published: boolean;
}>(addNamespace('deteriorationModels/updatePublishedStatusResolved'));

export const updatePublishedStatusRejected = createAction<Status>(
	addNamespace('deteriorationModels/updatePublishedStatusRejected'),
);
